<template>
    <div class="naef-bg" id="error">
        <main class="flex flex-1 flex-col items-center pb-10 pt-[126px] md:pt-[180px]">
            <div class="naef-carte p-9">
                <img
                    class="mx-auto h-[52px] w-auto"
                    src="@/assets/imgs/naef-projets-neufs-logo.svg"
                    alt="Naef Projets Neufs"
                />
                <img
                    class="mx-auto mt-4 h-[34px] w-auto"
                    src="@/assets/imgs/naef-logo.svg"
                    alt="e-promotion"
                />
                <p class="mt-8 text-center">
                    Oups, cette page n'existe pas
                </p>
                <div class="mt-6" v-if="user">
                    <span class="block w-full rounded-md shadow-sm cursor-pointer" @click="redirectHome">
                        <div class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-rouge-groseille hover:bg-rouge-groseille-150 focus:outline-none focus:border-rouge-groseille-150 transition duration-150 ease-in-out">
                          Retour à l'accueil
                        </div>
                    </span>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Auth from "@/mixins/Auth";
import Cookies from "js-cookie";
import Redirect from "@/mixins/Redirect";

export default {
    mixins: [Auth, Redirect],
    data() {
        return {};
    },
    computed: {
        ...mapState("auth", ["user"]),
    },
    mounted(){
        if(!this.user)
            this.$store.dispatch("auth/user");
    },
    methods: {
        goBack(){
            Cookies.remove("token");
            this.$router.push({name : "login"});
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = "E-Promotion | Erreur 404";
            }
        },
    },       
};
</script>
